export const DEFAULT_SLIDER_HEIGHT = 40
export const DEFAULT_THUMB_WIDTH = 20
export const DEFAULT_MARKER_WIDTH = 8
export const DEFAULT_MARKER_HEIGHT = 8
